/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import Modal from '../../UniformComponents/Modal'
import './creationWizard/creationWizard.scss'
import ChartAdvancedPreview from './creationWizard/ChartAdvancedPreview'
import DashboardWizardStore from './creationWizard/DashboardWizardStore'

@observer
class WidgetEditorPreviewModal extends Component {
    constructor(props) {
        super(props)
        const { dashStore } = props
        const { appStore } = dashStore
        this.dashboardWizardStore = new DashboardWizardStore(appStore, dashStore)
        this.state = {
            loading: true,
        }
    }

    componentDidUpdate(prevProps) {
        const { dashStore, widgetKey } = this.props
        const { loading } = this.state
        if (widgetKey && prevProps.widgetKey !== widgetKey) {
            const widgets = R.pathOr([{}], ['widgets'], dashStore)
            const widgetIndex = widgets.findIndex((w) => w.key === widgetKey)
            const widget = widgets[widgetIndex]
            this.widget = { ...widget }
            this.widgetIndex = widgetIndex

            this.init()
        } else if (!loading && !widgetKey) {
            this.setState({ loading: true })
        }
    }

    init = async () => {
        const {
            respondentType,
            productType,
            surveyType,
            industry,
            chartType,
            filter,
            widgetRenderSettings,
            scope,
            nonQuestionType,
            kpiType,
            questionTypeCode,
            questionId,
            benchmarkType,
            parentQuestion,
            width,
            multiQuestion,
            title,
            formId,
            qlistParentId,
            customTag,
            tagOptions,
            optionFilter,
        } = this.widget
        this.dashboardWizardStore.newWidget = {
            respondentType,
            productType,
            surveyType,
            industry,
            chart: chartType,
            filter,
            widgetRenderSettings,
            dataLevel: scope,
            nonQuestionType,
            questionTypeCode,
            displayAs: kpiType,
            timePeriod: benchmarkType,
            questionId,
            parentQuestion,
            widgetBasis: nonQuestionType || 'question',
            defaultSize: width,
            multiQuestion,
            widgetTitle: title,
            formId,
            qlistParentId,
            customTag,
            tagOptions,
            optionFilter,
        }
        let question = {}

        if (formId) {
            const formQuestion = await this.dashboardWizardStore.getQuestion(formId)
            question = {
                ...formQuestion.question.optionSet
                    .find((o) => o.question.id === questionId).question,
                formId,
            }
        } else {
            const questionResponse = !nonQuestionType
                ? await this.dashboardWizardStore.getQuestion(parentQuestion || questionId)
                : { question: undefined }
            question = questionResponse.question
        }
        if (question) { // reset the question type code for question row widgets
            question.questionTypeCode = questionTypeCode
        }

        await this.dashboardWizardStore.getKpis()
        this.dashboardWizardStore.newWidget.nonQuestionKpiType = nonQuestionType
            ? kpiType
            : undefined
        this.dashboardWizardStore.newWidget.question = question
        this.dashboardWizardStore.newWidget.isNumeric = this.getIsNumeric(question)
        this.setState({ loading: false })
    }

    getIsNumeric = (q) => {
        if (!q) return ''
        const { dashStore } = this.dashboardWizardStore
        const { oId } = dashStore
        if (['I', 'NF', 'NF - row', 'FM', 'PC', 'OD', 'OD - row'].includes(q.questionTypeCode)) return 'numeric'
        if (['RD'].includes(q.questionTypeCode)) {
            if (q.settings.frontend.renderNPS) return 'nps'
            return q.optionSet.hasNumericCodes ? 'numeric' : 'nonNumeric'
        }
        if (['CH', 'SB', 'OD'].includes(q.questionTypeCode)) {
            return q.optionSet.hasNumericCodes ? 'numeric' : 'nonNumeric'
        }
        if (['TB', 'TB - row'].includes(q.questionTypeCode)) return q.optionSetX.hasNumericCodes ? 'numeric' : 'nonNumeric'
        if (['SG'].includes(q.questionTypeCode)) return oId === 6 ? 'numericEvent' : 'numeric'
        return ''
    }

    validateLayoutEdit = (layoutEdit) => {
        let isValid = false
        try {
            const layoutEdits = JSON.parse(layoutEdit)
            isValid = layoutEdits.reduce((valid, l) => {
                if (!valid) return valid
                return Object.keys(l).includes('path') && Object.keys(l).includes('value') && l.path instanceof Array
            }, true)
        } catch (e) {
            isValid = false
        }
        return isValid
    }

    updateLayout = (newKey) => {
        const { dashStore, widgetKey } = this.props
        const { layouts } = dashStore
        return Object.keys(layouts).reduce((layout, k) => (
            {
                ...layout,
                [k]: layouts[k]
                    .map((l) => ({ ...l, i: l.i === widgetKey ? newKey : l.i })),
            }
        ), {})
    }

    updateWidget = () => {
        const { dashStore } = this.props
        const { updateWidget, updateLayouts, saveDashboard } = dashStore
        const { dashboardWizardStore } = this
        const newKey = uuidv4()
        const newLayout = this.updateLayout(newKey)
        const widget = dashboardWizardStore.addWidget(true)
        widget.key = newKey
        updateWidget(this.widgetIndex, widget)
        updateLayouts(newLayout)
        saveDashboard()
    }

    close = () => {
        const { toggleShowWidgetEditor } = this.props
        toggleShowWidgetEditor()
    }

    render() {
        const {
            showWidgetEditor, widgetKey,
        } = this.props
        const { loading } = this.state

        return (
            <Fragment>
                <Modal show={showWidgetEditor} onClose={this.close} cssClass="dashboardCreationWizard advancedPreview">
                    {widgetKey && !loading
                        ? (
                            <ChartAdvancedPreview
                                dashboardWizardStore={this.dashboardWizardStore}
                                editor
                                updateWidget={this.updateWidget}
                                close={this.close}
                            />
                        )
                        : null }
                </Modal>
            </Fragment>
        )
    }
}

export default WidgetEditorPreviewModal
